import { Component, OnInit } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    standalone: true,
    imports: [MatToolbarModule, MatButtonModule, RouterLink, RouterLinkActive, MatMenuModule]
})

export class HeaderComponent implements OnInit {

  constructor(private oauthService: OAuthService,
              private router: Router) {
  }

  ngOnInit() {

  }

  public logout() {
    window.sessionStorage.clear();
    this.oauthService.logOut(true);
    this.router.navigate(['logout']);
  }
}
